export class LoginCredentials {
	
	username: string;
	password: string;

	constructor(username: string, password: string){
		this.username=username;
		this.password=password;
	}
}

export class SignupCredentials {
	
	username: string;
	password: string;
	dealerType: string;

	constructor(username: string, password: string, dealerType: string){
		this.username=username;
		this.password=password;
		this.dealerType = dealerType;
	}
}



